import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  OnInit,
} from '@angular/core';
import { GuardhouseService } from '@rd/core/services/guardhouse/guardhouse.service';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { DialogRef } from '@rd/popup/dialog-ref';
import { ANZ_SSO_ENABLED } from '../../tokens/features.tokens';

@Component({
  selector: 'rd-anz-auth-secure-route-dialog',
  templateUrl: './auth-secure-route-dialog.component.html',
  styleUrls: ['./auth-secure-route-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzAuthSecureRouteDialogComponent implements OnInit {
  @HostBinding('class.anz-auth-secure-route-dialog') componentClass = true;

  isAnzSSOEnabled = inject(ANZ_SSO_ENABLED);

  constructor(
    private dialogRef: DialogRef,
    private guardhouseService: GuardhouseService,
    private iconRegistryService: IconRegistryService,
  ) {}

  ngOnInit(): void {
    this.iconRegistryService.registerIcon('close');
  }

  redirectToLoginUrl(): void {
    this.guardhouseService.redirectToLoginUrl();
  }

  redirectToEnrollUrl(): void {
    this.guardhouseService.redirectToEnrollUrl();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
